<template>
    <div class="kiaf-tag-group">
        <business-map-tag-group v-if="taggroupMode === 'business&map'" :customize="customize" :customizeNavbar="customizeNavbar">
            <template #taggroupBreadcrumb><slot name="taggroupBreadcrumb"></slot></template>
        </business-map-tag-group>
        <photo-tag-group v-else-if="taggroupMode === 'photo'" :customize="customize" :customizeNavbar="customizeNavbar"></photo-tag-group>
    </div>
</template>
<script>
    import BusinessMapTagGroup from './BusinessMapTagGroup/index';
    import PhotoTagGroup from './PhotoTagGroup/index';

    export default {
        name: 'KiafTagGroup',
        components: {
            BusinessMapTagGroup,
            PhotoTagGroup
        },
        computed: {
          taggroupMode() {
            return this.customize.mode || this.mode;
          }
        },
        props: {
            mode: {
                type: String,
                default: 'business&map'//'business&map' or 'simple'
            },
          customize: {
            type: Object,
            default(){
              return {
              };
            }
          },
          customizeNavbar: {
            type: Object,
            default(){
              return {
              };
            }
          }
        }
    };
</script>
